import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
type Tier = {
  id: string;
  badge: string | null;
  title: string;
  tagline: string;
  price: string;
  oldPrice?: string;
  includes: string[];
  highlight?: string;
  cta: string;
  href: string;
  featured: boolean;
};
const TIERS: Tier[] = [{
  id: 'integral',
  badge: null,
  title: 'MEGAPACK ASTROLOGÍA INTEGRAL',
  tagline: 'La formación completa',
  price: '$13',
  includes: ['6 Módulos Profesionales', '4 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato', 'Acceso Ilimitado', 'Formación Completa'],
  cta: 'Quiero el MegaPack',
  href: 'https://pay.hotmart.com/M106419692A?bid=1781988282366',
  featured: false
}, {
  id: 'premium',
  badge: '⭐ MÁS ELEGIDO',
  title: 'MEGAPACK PREMIUM ✨',
  tagline: 'La experiencia astrológica definitiva',
  price: '$19',
  oldPrice: '$39',
  highlight: '🔥 Todo lo del MegaPack + 2 bonos exclusivos para llevar tus lecturas al siguiente nivel',
  includes: ['Todo lo incluido en el MegaPack', '❤️ Bono Exclusivo: Astrología de Compatibilidad de Parejas', '📖 Bono Exclusivo: Vademécum de Astrología Profesional'],
  cta: 'Quiero el Premium',
  href: 'https://pay.hotmart.com/N106444197J',
  featured: true
}];
function TierCard({
  tier,
  index
}: {
  tier: Tier;
  index: number;
}) {
  const [ref, vis] = useReveal();
  const featured = tier.featured;
  return <div ref={ref} className={`reveal relative flex flex-col rounded-2xl p-6 md:p-8 shadow-xl transition-all ${featured ? 'bg-[#1a1f3d] border-2 border-[#d4af37]' : 'bg-[#11152e] border border-[#d4af37]/20'} ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 80}ms`
  }} data-id="element-143">
      {tier.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#d4af37] text-[#0a0e1f] text-xs font-bold tracking-[0.2em] px-6 py-2 rounded-full whitespace-nowrap shadow-md" data-id="element-144">
          {tier.badge}
        </div>}

      <h3 className="text-base md:text-lg font-serif font-bold text-[#f5f1e6] mb-1 text-center mt-1.5 leading-tight" data-id="element-145">
        {tier.title}
      </h3>
      {tier.tagline && <p className={`text-center text-xs font-semibold mb-3 ${featured ? 'text-[#d4af37]' : 'text-[#8b91ad]'}`} data-id="element-146">
          {tier.tagline}
        </p>}

      {tier.highlight && <div className="bg-[#d4af37]/10 border border-[#d4af37]/40 rounded-xl p-2.5 mb-3 text-center" data-id="element-147">
          <p className="text-[#d4af37] text-xs font-bold leading-snug" data-id="element-148">
            {tier.highlight}
          </p>
        </div>}

      <div className="bg-[#0a0e1f] rounded-xl p-3.5 mb-4 border border-[#d4af37]/15 flex-grow" data-id="element-149">
        <p className="text-[#8b91ad] text-[11px] font-bold uppercase tracking-wider mb-2.5" data-id="element-150">
          Incluye:
        </p>
        <ul className="space-y-1.5" data-id="element-151">
          {tier.includes.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-152">
              <span className="text-[#d4af37] font-bold text-sm flex-shrink-0" data-id="element-153">
                ✓
              </span>
              <span className="text-[#cbd0e0] text-[13px] font-medium leading-snug" data-id="element-154">
                {item}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-4" data-id="element-155">
        <p className="text-[#d4af37] text-[11px] font-bold uppercase tracking-widest mb-0.5" data-id="element-156">
          Precio final
        </p>
        <div className="flex items-baseline justify-center gap-1.5" data-id="element-157">
          {tier.oldPrice && <span className="text-[#8b91ad] text-lg font-semibold line-through mr-1" data-id="element-158">
              {tier.oldPrice}
            </span>}
          <span className="text-3xl md:text-4xl font-extrabold text-[#f5f1e6] leading-none" data-id="element-159">
            {tier.price}
          </span>
          <span className="text-[#8b91ad] text-sm font-semibold" data-id="element-160">USD</span>
        </div>
        <p className="text-[#8b91ad] text-[11px] font-medium mt-1.5" data-id="element-161">
          Pagás en la moneda de tu país.
        </p>
      </div>

      <a href={tier.href} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
      content_name: tier.title,
      value: Number(tier.price.replace(/[^0-9]/g, '')),
      currency: 'USD'
    })} className={`w-full block py-3.5 rounded-xl font-bold text-sm tracking-widest uppercase text-center transition-all hover:-translate-y-1 ${featured ? 'bg-[#d4af37] hover:bg-[#c19b2e] text-[#0a0e1f] shadow-[0_8px_20px_rgba(212,175,55,0.35)] hover:shadow-[0_12px_25px_rgba(212,175,55,0.45)]' : 'bg-[#1a1f3d] hover:bg-[#232a4d] text-[#d4af37] border border-[#d4af37]/50 shadow-md'}`} style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-162">
        👉 {tier.cta}
      </a>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#0a0e1f] py-10 md:py-16 px-4 sm:px-6 border-t border-[#ffffff]/5" style={{
    scrollMarginTop: '80px'
  }} data-id="element-163">
      <div className="container mx-auto max-w-4xl" data-id="element-164">
        <div ref={ref1} className={`reveal text-center mb-5 md:mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-165">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] mb-2.5" data-id="element-166">
            ELEGÍ COMENZAR HOY
          </h2>
          <p className="text-[#cbd0e0] text-sm md:text-base max-w-xl mx-auto" data-id="element-167">
            Empezá hoy tu formación con acceso inmediato y certificado digital
            incluido.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-7 max-w-3xl mx-auto items-start" data-id="element-168">
          {TIERS.map((tier, i) => <TierCard key={tier.id} tier={tier} index={i} data-id="element-169" />)}
        </div>

        <div className="mt-8 text-center space-y-2" data-id="element-170">
          <p className="text-[#8b91ad] text-xs font-medium" data-id="element-171">
            ⚡ Acceso inmediato luego de completar tu compra.
          </p>
          <p className="text-[#8b91ad] text-xs font-medium" data-id="element-172">
            🛡️ Garantía de satisfacción de 7 días.
          </p>
        </div>
      </div>
    </section>;
}